import {Component, computed, effect, input, model, signal} from '@angular/core'
import {MatFormField, MatInput, MatLabel} from '@angular/material/input'
import {MatOption} from '@angular/material/core'
import {IItem, IOwner} from '../../../0-application/types'
import {IFlatItem} from '../list/list'
import {MatSelect} from '@angular/material/select'
import {FormsModule} from '@angular/forms'

@Component({
  selector: 'spb-filter',
  imports: [
    MatFormField,
    MatLabel,
    MatOption,
    MatSelect,
    FormsModule,
    MatInput
  ],
  templateUrl: './filter.html',
  styleUrl: './filter.scss'
})
export class Filter {
  public items = input.required<IItem[]>()

  public filtered = model.required<IFlatItem[]>()

  public advisors = computed(() => {
    const set = new Set(this.items()
      .filter(l => l.collections?.owners)
      .map(l => l.user?.name))

    return [...set.values()]
      .filter(Boolean)
      .toSorted((a, b) => a.localeCompare(b, 'sv-SE'))
  })

  public offices = computed(() => {
    const set = new Set(this.items()
      .filter(l => l.collections?.owners)
      .map(l => l.user?.office))

    return [...set.values()]
      .filter(Boolean)
      .toSorted((a, b) => a.localeCompare(b, 'sv-SE'))
  })

  public advisor = signal<string>('')
  public office = signal<string>('')

  public text = signal<string>('')

  constructor() {
    effect(() => {
      const flat = this.flat(this.items())
      const filtered = this.filter(flat)
      this.filtered.set(filtered)
    })
  }

  public flat(items: IItem[]): IFlatItem[] {
    return items
      .filter(i => i.collections?.owners)
      .map((item: IItem) => {
        const owners: IOwner[] = item.collections.owners!
        return {
          id: item.id,
          date: item.updatedAt,
          sub: owners.map(o => o.sub).join(''),
          subs: owners.map(o => o.sub),
          name: owners.map(o => `${o.name}`).join(''),
          names: owners.map(o => `${o.name}`),
          advisor: item.user?.name,
          office: item.user.office,
          status: item.approvalStatus,
          step: item.approvalStatus === 'created' ? 1 : 5
        }
      })
      .toSorted((a, b) => b.date - a.date)
  }

  public filter(items: IFlatItem[]) {
    return items
      .filter(i => i.advisor.includes(this.advisor()))
      .filter(i => i.office?.includes(this.office()))
      .filter(i => {
        const t = this.text().toLocaleLowerCase().trim().replaceAll('- ', '')
        const s = `${i.sub}${i.name}${i.advisor}${i.office}`.toLowerCase().trim().replaceAll('- ', '')
        return s.includes(t)
      })
  }
}
